export enum EmailCreationEnum {
    createAttachments,
    addAttachmments,
    createShareableLinks,
    addShareableLinks,
}

export enum EmailCreationTypeEnum {
    Attachments,
    ShareableLinks,
}